module.exports = __webpack_public_path__ + "img/ai-icon.52ced672.svg";